/*
 * @Author: cc
 * @LastEditTime: 2022-06-17 17:21:06
 */
// import  { useEffect,useState } from "react";
// import { IsPc } from "../utils/index";
import Style from "./index.module.scss"
import "moment/locale/zh-cn";
import { useLocation  } from "react-router-dom";
// import {get} from "../component/fetch"
// import store from '../reducers/index'
import logo from "../../../img/logo.png"
import { useEffect,useState } from "react";
import { get } from "src/component/fetch";
import store from "../../../reducers"
import { connect } from "react-redux";
export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
export interface Category {
  zhName: string;
  enName: string;
  required: boolean;
  fieldType: string;
  tips?: string;
  placeholder?: string;
  selectOptions: string[];
  id: number;
}

const Header = (props:any) => {
  // const query = useQuery()
  // const subjectId = query.get('subjectId')
  // const [logo,setLogo] = useState('')
  // const [orderNum,setOrderNum] = useState('')
  // const watchType = query.get('watchType') || ''
  // const getLogo = () => {
  //   get(`/shop/front/ge/column/subject/getDetail2?subjectId=${subjectId}${watchType ? '&watchType='+ watchType : ''}`,{},false).then(res=>{
  //     if(res.code === 0){
  //       setLogo(res.data.logoUrl)
  //       setOrderNum(res.data.orderNum)
  //     }
  //   })
  // }
  useEffect(()=>{
    // getLogo()
  },[])
  return (
    <>
        <div className={Style.logo}><img src={props.InitPageData ? props.InitPageData.logoUrl:''} alt=""></img><span>第{props.InitPageData.orderNum}期</span></div>
    </>
  );
};
const mapStateToProps = (state:any) => ({
  InitPageData: state.InitPageData, // 映射仓库中的某个变量到组件的props
});
export default connect(mapStateToProps)(Header);
